import { render, staticRenderFns } from "./SKPPLT.vue?vue&type=template&id=1724b10a&scoped=true&lang=html&"
import script from "./SKPPLT.vue?vue&type=script&lang=js&"
export * from "./SKPPLT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724b10a",
  null
  
)

export default component.exports